export enum ThunkErrors {
  Abort = 'AbortError',
}
